import { Component, OnInit } from '@angular/core';
import { Validators } from '../../../../shared/validators';
import { FormGroup } from '@angular/forms';
import { FormValidatorService } from 'src/app/shared/services/form-validator.service';
import { TranslateService } from '@ngx-translate/core';
import { ContactUsService } from 'src/app/public-website/buyer/services/contactUs.service';
import Swal from 'sweetalert2';
import { ReCaptchaService } from 'angular-recaptcha3';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss'],
})
export class ContactComponent implements OnInit {
  contactForm: FormGroup;
  validationError!: [
    {
      field: string;
      message: string;
      validation: string;
    },
  ];
  constructor(
    public formValidator: FormValidatorService,
    private translate: TranslateService,
    private contactUsService: ContactUsService,
    private recaptchaService: ReCaptchaService,
  ) {}

  ngOnInit(): void {
    this.contactForm = this.formValidator.createForm([
      {
        fieldName: 'name',
        defaultValue: null,
        validators: [
          {
            validatorFn: Validators.required,
            message: '',
          },
        ],
      },
      {
        fieldName: 'subject',
        defaultValue: null,
        validators: [
          {
            validatorFn: Validators.required,
            message: '',
          },
        ],
      },
      {
        fieldName: 'email',
        defaultValue: null,
        validators: [
          {
            validatorFn: Validators.required,
            message: '',
          },
          {
            validatorFn: Validators.email,
            message: '',
          },
        ],
      },
      {
        fieldName: 'message',
        defaultValue: null,
        validators: [
          {
            validatorFn: Validators.required,
            message: '',
          },
        ],
      },
    ]);

    this.translateValidationMessages();
    this.translate.onLangChange.subscribe(() => {
      this.translateValidationMessages();
    });
  }

  translateValidationMessages() {
    this.translate.get('FormValidation').subscribe(() => {
      this.formValidator.validationMessages = {
        name: {
          required: this.translate.instant('FormValidation.Empty', {
            field: 'Name',
            fieldAr: 'الإسم',
          }),
        },
        subject: {
          required: this.translate.instant('FormValidation.Empty', {
            field: 'Subject',
            fieldAr: 'الموضوع',
          }),
        },
        email: {
          required: this.translate.instant('FormValidation.Empty', {
            field: 'Email',
            fieldAr: 'البريد الاكتروني',
          }),
          email: this.translate.instant('FormValidation.ValidEmail', {
            field: 'email',
            fieldAr: 'البريد الاكتروني',
          }),
        },
        message: {
          required: this.translate.instant('FormValidation.Empty', {
            field: 'Message',
            fieldAr: 'الرسالة',
          }),
        },
      };
    });
  }

  async sendMessage(messageDetails: ContactUsInterface) {
    const recaptchaToken = await this.recaptchaService.execute({
      action: 'contactUs',
    });
    const contactBody = {
      email: messageDetails.email,
      subject: messageDetails.subject,
      message: messageDetails.message,
      recaptchaToken,
    };
    this.contactForm.reset();
    this.contactUsService.setParams(contactBody);
    await this.contactUsService
      .make()
      .then((e) => {
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Thank you for getting in touch!',
          text: 'We appreciate you contacting Easykash.One of our colleagues will get back in touch with you soon! Have a great day!',
          showConfirmButton: false,
          timer: 1500,
        });
      })
      .catch((err) => {
        Swal.fire({
          position: 'center',
          title: 'Oops...',
          text: 'Something went wrong!Please try again later',
          showConfirmButton: false,
          timer: 1500,
        });
      });
  }
}

export interface ContactUsInterface {
  email: string;
  subject: string;
  message: string;
}
